module.exports = __webpack_public_path__ + "static/media/CreateUser3.65e068a9.png";